import React, { useState, useEffect } from "react";
import order from "@api/order";
import { useRangerOptional } from "@context/rangerContext";

const OrderBook = (market) => {
  const ranger = useRangerOptional();
  const useWs = Boolean(ranger?.enabled);
  const [state, setState] = useState({
    sells: [],
    buys: [],
    is_fetch: false,
  });

  useEffect(() => {
    if (!useWs || !market || !ranger?.subscribeMarket) return undefined;
    const route = String(market).replace(/_/g, "-");
    ranger.subscribeMarket(route);
    return () => ranger.unsubscribeMarket?.();
  }, [useWs, market, ranger?.subscribeMarket, ranger?.unsubscribeMarket]);

  useEffect(() => {
    if (useWs && ranger?.connected) {
      setState({
        sells: ranger.depth?.sells || [],
        buys: ranger.depth?.buys || [],
        is_fetch: Boolean(ranger.depth?.is_fetch),
      });
      return undefined;
    }

    let timer = null;
    (function fetch() {
      order
        .getMarketOrderBook1({
          params: {
            market: market,
          },
        })
        .then((res) => {
          setState((prevState) => ({
            ...prevState,
            sells: res.content.sells,
            buys: res.content.buys,
            is_fetch: true,
          }));
        })
        .catch((data) => {
          console.log(data?.message);
        });
      timer = setTimeout(fetch, 8 * 1000);
    })();

    return () => clearTimeout(timer);
  }, [market, useWs, ranger?.connected, ranger?.depth]);

  return {
    ...state,
  };
};
export default OrderBook;
